 
import { Container, Row, Col } from "reactstrap";
import {
    WorkspacePremium,
    BusinessCenter,
    School,
    ArrowForward
} from "@mui/icons-material";

import "./CAD_Why_FeesWorth.css";

const defaultItems = [
    {
        number: "01",
        icon: <WorkspacePremium />,
        title: "10 Years of Teaching",
        description: (
            <>
                For the past decade, we have passionately and consistently{" "}
                <strong>specialized in CAD Automation & Customization</strong>{" "}
                training. Our unwavering commitment to this niche field has
                allowed us to accumulate a wealth of experience and expertise.
                Over the years, we have honed our training programs to
                perfection, ensuring that our students receive the highest
                quality education in this vital aspect of CAD technology. This
                extensive experience has enabled us to provide our students
                with valuable insights and knowledge that are not just
                theoretical but also practical, setting them on a path to
                success in a competitive job market
            </>
        )
    },
    {
        number: "02",
        icon: <BusinessCenter />,
        title: "We work on real projects for MNC",
        description: (
            <>
                We take pride in our collaboration with renowned companies
                such as <strong>Donaldson in the UAE</strong>,{" "}
                <strong>Honeywell in the USA</strong>, and{" "}
                <strong>Proclass in the Netherlands</strong>. Over the years,
                we have successfully undertaken and delivered cutting-edge{" "}
                <strong>CAD Automation & Customization projects for these
                distinguished clients</strong>. These partnerships stand as a
                testament to our capabilities and the trust these global
                organizations have placed in our expertise. Our commitment to
                innovation and precision ensures that we continue to provide
                tailored solutions that meet the unique needs of our clients
                and make a significant impact in their respective industries.
            </>
        )
    },
    {
        number: "03",
        icon: <School />,
        title: "We have delivered many corporate training",
        description: (
            <>
                We also take pride in our successful track record of
                delivering comprehensive corporate training in CAD Automation
                and Customization.{" "}
                <strong>
                    Our tailored programs have been well-received by esteemed
                    companies like Molex, Bradken, Mold-Masters, and Valeo.
                </strong>{" "}
                These collaborations attest to our ability to address the
                unique needs of leading organizations, providing their teams
                with the specialized skills and knowledge required to excel in
                CAD Automation and Customization. This recognition in the
                corporate world reinforces our commitment to excellence and the
                valuable impact our training has on both individuals and
                businesses
            </>
        )
    }
];

function CADWhyFeesWorth({
    title = "Why Learn From FeesWorth?",
    items = defaultItems
}) {
    return (
        <section className="cad-why-feesworth">
            <Container>
                {/* Header */}
                <div className="cad-feesworth-header text-center">
                    <span className="cad-feesworth-badge">
                        <WorkspacePremium fontSize="small" />
                        WHY FEESWORTH
                    </span>

                    <h2>{title}</h2>

                    <p>
                        Learn from experience, real-world projects, and
                        industry-focused training.
                    </p>

                    <div className="cad-feesworth-divider">
                        <span></span>
                    </div>
                </div>

                {/* Content */}
                <div className="cad-feesworth-list">
                    {items.map((item, index) => (
                        <Row
                            key={item.number}
                            className={`cad-feesworth-row ${
                                index % 2 !== 0
                                    ? "cad-feesworth-row-reverse"
                                    : ""
                            }`}
                        >
                            {/* Image / Visual */}
                            <Col
                                lg="5"
                                className="d-flex align-items-center"
                            >
                                <div className="cad-feesworth-visual">
                                    {index === 0 && (
                                        <img
                                            src="https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1024,h_683/https://feesworth.com/wp-content/uploads/2023/09/19245711_6101073-1024x683.jpg"
                                            alt="CAD Automation and Customization training"
                                            loading="lazy"
                                        />
                                    )}

                                    {index === 1 && (
                                        <img
                                            src="https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1024,h_1024/https://feesworth.com/wp-content/uploads/2023/09/2945521_28662-1024x1024.jpg"
                                            alt="CAD Automation real projects"
                                            loading="lazy"
                                        />
                                    )}

                                    {index === 2 && (
                                        <img
                                            src="https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_1024,h_1024/https://feesworth.com/wp-content/uploads/2023/09/7176408_3572685-1024x1024.jpg"
                                            alt="Corporate CAD training"
                                            loading="lazy"
                                        />
                                    )}

                                    <div className="cad-feesworth-image-overlay"></div>

                                    <div className="cad-feesworth-image-number">
                                        {item.number}
                                    </div>
                                </div>
                            </Col>

                            {/* Content */}
                            <Col
                                lg="7"
                                className="d-flex align-items-center"
                            >
                                <div className="cad-feesworth-content">
                                    <div className="cad-feesworth-icon">
                                        {item.icon}
                                    </div>

                                    <div className="cad-feesworth-title-row">
                                        <span>{item.number}</span>
                                        <h3>{item.title}</h3>
                                    </div>

                                    <p>{item.description}</p>

                                    <div className="cad-feesworth-accent">
                                        <ArrowForward fontSize="small" />
                                        <span>Industry Focused Learning</span>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    ))}
                </div>
            </Container>
        </section>
    );
}

export default CADWhyFeesWorth;